class Header {
	constructor(config) {
		this.config = Object.assign({
			scope: '.header-menu',
			toggle: '.dropdown-toggle'
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.$scope.on('click', this.config.toggle, (e) => {
			let check = $(e.currentTarget).attr('aria-expanded') == 'true';
			if(check) {
				this.$scope.addClass('active-dropdown');
			} else {
				this.$scope.removeClass('active-dropdown');
			}
		});
	}
}

export default new Header;